import { faFilter } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import Button from "components/components/Button/Button";
import { SvgIconName } from "components/components/Icon/Icon";
import React from "react";
import featureFlags from "utils/featureFlags";

import { ChartFilterButtonContainer } from "./style";

const ChartFilterButton: React.FC<{
  toggleChartFilterDrawer?: () => void;
  showChartFilterDrawer?: boolean;
}> = ({ toggleChartFilterDrawer, showChartFilterDrawer }) => (
  <ChartFilterButtonContainer data-test-id="chart-filter-button-container">
    {toggleChartFilterDrawer && (
      <Button
        onClick={toggleChartFilterDrawer}
        className={classnames("toggle", { active: showChartFilterDrawer })}
        buttonText="Filter"
        iconName={featureFlags.rebrand ? SvgIconName.Filter : faFilter}
      />
    )}
  </ChartFilterButtonContainer>
);

export default ChartFilterButton;
